module.exports = __webpack_public_path__ + "assets/img/xwyb.c29db614.jpg";